import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { useState } from 'react';
import styled from 'styled-components';
import { useLazyImage } from '../LazyImageProvider';
import { ListingActionMenu } from '../ListingActionMenu';
import { PolymorphicLink } from '../PolymorphicLink';
import { translateProductType } from '../utils/translateProductType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledActionMenuWrapper = styled.div.withConfig({
  displayName: "EcosystemListingStub__StyledActionMenuWrapper",
  componentId: "sc-1wky28h-0"
})(["margin-inline-start:auto;opacity:", ";:focus-within{opacity:1;}"], ({
  isHovered
}) => isHovered ? 1 : 0);
export function EcosystemListingStub({
  imageSrc,
  name,
  productType,
  providerName,
  actions = [],
  bordered = false,
  compact = false,
  ctaLabel,
  installed = false,
  linkMode = 'default',
  listingHref,
  onActionClick = () => {},
  onClick,
  onCtaClick,
  ribbonText,
  ribbonUse
}) {
  const lazyImage = useLazyImage();
  const [isHovered, setIsHovered] = useState(false);
  return /*#__PURE__*/_jsxs(Flex, {
    borderColor: 'border-core-subtle',
    borderRadius: "200",
    borderStyle: bordered ? 'solid' : 'none',
    borderWidth: "100",
    inlineSize: "100%",
    onClick: onClick,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    padding: bordered ? '300' : '0',
    position: "relative",
    children: [ribbonText && /*#__PURE__*/_jsx(Ribbon, {
      use: ribbonUse,
      position: "right",
      children: ribbonText
    }), /*#__PURE__*/_jsx(PolymorphicLink, {
      href: listingHref,
      linkMode: linkMode,
      use: "unstyled",
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "400",
        alignItems: installed ? undefined : 'center',
        children: [/*#__PURE__*/_jsx(Image, {
          alt: name,
          blockSize: compact ? '32px' : '48px',
          loading: lazyImage,
          objectFit: "cover",
          src: imageSrc
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: compact ? 'h6' : 'h5',
            children: name
          }), /*#__PURE__*/_jsx(Text, {
            as: "small",
            color: "text-core-subtle",
            marginBlockStart: compact ? '0' : '50',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "trellisEcosystem.listingStub.subtitle",
              options: {
                productType: translateProductType(productType),
                providerName
              }
            })
          }), installed && /*#__PURE__*/_jsx(StatusTag, {
            marginBlockStart: compact ? '50' : '100',
            use: "success",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "trellisEcosystem.listingStub.installed"
            })
          })]
        })]
      })
    }), ctaLabel && /*#__PURE__*/_jsx(Button, {
      marginInlineStart: "auto",
      onClick: onCtaClick,
      use: "transparent",
      children: ctaLabel
    }), actions.length > 0 &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledActionMenuWrapper, {
      isHovered: isHovered,
      children: /*#__PURE__*/_jsx(ListingActionMenu, {
        actions: actions,
        onActionClick: onActionClick
      })
    })]
  });
}